// native
import { NgModule } from "@angular/core";
import { SharedModule } from '../shared/shared.module';

// component
import { OptionsComponent } from './options.component';
import { CustomStyleComponent } from './components/custom-style/custom-style.component';
import { MatcherComponent } from './components/matcher/matcher.component';
import { ReferencesModule } from "../references/references.module";

@NgModule({
  imports: [
    SharedModule,
    ReferencesModule
  ],
  declarations: [
    OptionsComponent,
    CustomStyleComponent,
    MatcherComponent
  ],
  exports: [ 
    OptionsComponent
   ]
})
export class OptionsModule { }